import { format, formatISO, isValid, parse, parseISO } from "date-fns";
import moment from 'moment';

export function toDateStringISO(date) {
    return formatISO(date, { representation: "date" });
}

export function toDateStringLocale(date) {
    if (typeof date === "string") {
        date = parseISO(date);
    }

    return format(date, "dd.MM.yyyy");
}

export function toDateStringLocaleShort(date) {
    if (typeof date === "string") {
        date = parseISO(date);
    }

    return format(date, "dd.MM.yy");
}

export function toShortDateStringLocale(date) {
    if (typeof date === "string") {
        date = parseISO(date);
    }

    return format(date, "dd.MM");
}

export function toDayStringLocale(date) {
    if (typeof date === 'string') {
        date = parseISO(date);
    }

    return format(date, 'dd');
}

export function toTimeStringLocale(time) {
    if (typeof time === "string") {
        time = parseISO(time);
    }

    return format(time, "HH:mm");
}

export function parseTime(time) {
    return parse(time, "HH:mm", new Date(2000, 0, 1));
}

export function isValidTime(time) {
    try {
        const parsedTime = parseTime(time);
        if (!isValid(parsedTime)) {
            return false;
        }
    } catch {
        return false;
    }

    return true;
}

export function getPluralFormOfYear(number) {
    const mod10 = number % 10;
    const mod100 = number % 100;
    return mod100 >= 5 && mod100 <= 20
        ? "лет"
        : mod10 === 1
        ? "год"
        : mod10 >= 2 && mod10 <= 4
        ? "года"
        : "лет";
}

export function getYear(date) {
    return parseISO(date).getFullYear();
}

export function getDatesFromDateRange(startDate, endDate) {
    let dateArray = [];
    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
        dateArray.push(new Date (currentDate));
        currentDate = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate() + 1);
    }
    return dateArray;
}

export function getShortTime(time){
    return moment(time, 'HH:mm:ss').format('HH:mm')
}

export function getMomentTime(time){
    return moment(time, 'HH:mm:ss');
}

export function getMomentTimeFromShort(time){
    return moment(time, 'HH:mm');
}